/**
 * Application Constants
 */

export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
  TERMINAL: 'terminal',
};

export const THEME_ICONS = {
  [THEMES.LIGHT]: '☀️',
  [THEMES.DARK]: '🌙',
  [THEMES.TERMINAL]: '💻',
};

export const THEME_LABELS = {
  [THEMES.LIGHT]: 'Dark',
  [THEMES.DARK]: 'Terminal',
  [THEMES.TERMINAL]: 'Light',
};

export const TYPING_TEXTS = [
  'Senior iOS/macOS Engineer',
  'AI/ML Integration Specialist',
  'Software Architect',
  'Team Leader & Mentor',
  '13+ Years of Innovation',
];

export const TYPING_SPEED = 100;
export const TYPING_DELETE_SPEED = 50;
export const TYPING_PAUSE = 2000;

export const SCROLL_OFFSET = 80;
export const ANIMATION_THRESHOLD = 0.1;

export const CDN_URLS = {
  THREE_JS: 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js',
  CHART_JS: 'https://cdn.jsdelivr.net/npm/chart.js@3.9.1/dist/chart.min.js',
};

export const KONAMI_CODE = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a',
];

export const EASTER_EGG_TAPS = 7;
